module.exports = "../../app/cells/components/banner_approval_cta_cell.rb";